/**
 * FontAwesome Pro 6.7.2 — Shadow DOM Injection
 * Include ${iconStyles} at the top of every Lit component render() method.
 * Browser caches the CSS; @font-face declarations are document-level.
 */
import { html } from 'lit';

export const iconStyles = html`
  <link rel="stylesheet" href="/rvbtsystem/site/resources/fontawesome-pro/css/fontawesome.min.css">
  <link rel="stylesheet" href="/rvbtsystem/site/resources/fontawesome-pro/css/sharp-light.min.css">
  <link rel="stylesheet" href="/rvbtsystem/site/resources/fontawesome-pro/css/sharp-solid.min.css">
  <link rel="stylesheet" href="/rvbtsystem/site/resources/fontawesome-pro/css/sharp-duotone-solid.min.css">
`;
